
import EventEmitter from '../../../../helpers/EventEmmiter';
import './style.scss';

export default class Magnify extends EventEmitter {
    _glass= null;
    _isFirst = true;
    _captureCanvas = null;
    _zoom = 2;
    _hidden = false;
    _listener = {
        mousemove: (event) => {
            if(this._hidden) return true;

            this._mouseX = event.clientX;
            this._mouseY = event.clientY;
            this.show();
        },
        mouseup: () => {
            this._magnifiedGlassSrc();
        }
    }
    _moveMagnifierEvent = (e) => {
        this._moveMagnifier(e);
    }

    constructor(wrapper) {
       super();
    
       this._wrapper = wrapper;
       
       this._init();
    }

    _magnify() {
        if(!this._isFirst) return ;

        this._isFirst = false;
        this._preview.parentElement.insertBefore(this._glass, this._preview);

        this._glass.style.backgroundImage = "url('" + this._preview.src + "')";
        this._glass.style.backgroundRepeat = "no-repeat";
        this._glass.style.backgroundSize = (this._preview.width * this._zoom) + "px " + (this._preview.height * this._zoom) + "px";
        this._bw = 3;
        this._w = this._glass.offsetWidth / 2;
        this._h = this._glass.offsetHeight / 2;

        document.body.addEventListener("mousemove", this._moveMagnifierEvent);
    }

    _moveMagnifier(e) {
        e.preventDefault();
        const w = this._w;
        const h = this._h;
        const bw = this._bw;
       
        try{
            const pos = this._getCursorPos(e);
            let x = pos.x;
            let y = pos.y;
    
            if (x > this._preview.width - (w / this._zoom)) {x = this._preview.width - (w / this._zoom);}
            if (x < w / this._zoom) {x = w / this._zoom;}
            if (y > this._preview.height - (h / this._zoom)) {y = this._preview.height - (h / this._zoom);}
            if (y < h / this._zoom) {y = h / this._zoom;}
            this._glass.style.left = (x - w) + "px";
            this._glass.style.top = (y - h) + "px";
            this._glass.style.backgroundPosition = "-" + ((x * this._zoom) - w + bw) + "px -" + ((y * this._zoom) - h + bw) + "px";
        }catch(e){
            console.log(e);
            this.destroy();  
        }
    }

    _getCursorPos(e) {
        var a, x = 0, y = 0;
        e = e || window.event;
        a = this._preview.getBoundingClientRect();
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return {x : x, y : y};
    }

    _createGlass() {
        const preview = document.createElement("img");
        preview.id = "magnified-view";

        const glass = document.createElement("DIV");
        glass.classList.add("img-magnifier-glass");
        glass.style.top = '-99999px';
        glass.style.left = '-99999px';

        return {preview, glass};
    }

    _init() {
        const {preview, glass} = this._createGlass();
        this._preview = preview;
        this._glass = glass;
        
        this._wrapper.appendChild(this._preview);

        this._preview.onload = () => {
            this._magnify();
            
            if(this._glass){
                this._glass.style.backgroundImage = "url('" + this._preview.src + "')";
            }
        }

        this._listenerKey();
        this._magnifiedGlassSrc();
    }

    _createCanvas = (origin) => {
        try{
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = origin.width;
            canvas.height = origin.height;
            context.drawImage(origin, 0, 0);
    
            return canvas;
        }catch(e){
            console.log(e);
            this.destroy();
        }
    }

    hide(){
        this._glass.classList.add('hidden');
        this._hidden = true;
    }

    show(){
        this._glass.classList.remove('hidden');
        this._hidden = false;
    }

    _magnifiedGlassSrc = () => {
        const origin = document.body.querySelector(".e3-viewer-pannellum-wrapper .pnlm-render-container canvas");
        this._captureCanvas = this._createCanvas(origin);
        if(!this._captureCanvas) return true;

        const dataURL = this._captureCanvas.toDataURL('image/png', 1);

        this._preview.src = dataURL; 
    }

    _listenerKey() {
        Object.keys(this._listener)
            .forEach((key) => {
                document.addEventListener(key, this._listener[key]);
            })
    }

    destroy() {
        Object.keys(this._listener)
        .forEach((key) => {
            document.removeEventListener(key, this._listener[key]);
        })
        document.body.removeEventListener("mousemove", this._moveMagnifierEvent);

        if (this._wrapper.contains(this._preview)) {
            this._wrapper.removeChild(this._preview);
        }

        this._captureCanvas = null;
        this._glass = null;
        this._preview = null;
    }
}